import en, { type Messages } from "./en";

// Add a locale by importing its dictionary and adding a line here -- LocaleProvider,
// LanguageSwitcher, and every `t()` call site need no changes when a new one is added.
export const DICTIONARIES: Record<string, Messages> = {
  en,
};
